<template>
  <view :class="['goods-item', 'goods-item-' + position]" @click.stop="goToGoodsDetail(mid)">
    <view class="image-wrapper">
      <u-lazy-load :duration="300" threshold="-200" border-radius="10" :image="iconSpu" :index="index"></u-lazy-load>
    </view>
    <text class="goods-name">{{ nameSpu }}</text>
    <view class="goods-price-wrap">
      <text class="goods-price-old">￥{{ priceOld }}</text>
      <text :style="{ '--primary-color': primaryColor }" class="goods-price">￥{{ price }}</text>
    </view>
  </view>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'goods-item',
  props: {
    // 商品所在列表的下标 用户 LazyLoad 懒加载组件
    index: {
      type: Number,
      default: null,
    },
    // 商品所在列的位置 left , right
    position: {
      type: String,
      default: null,
    },
    // 商品mid
    mid: {
      type: String,
      default: null,
    },
    // 商品图片
    iconSpu: {
      type: String,
      default: null,
    },
    // 商品名称
    nameSpu: {
      type: String,
      default: null,
    },
    // 划线价
    priceOld: {
      type: Number,
      default: null,
    },
    // 商品价格
    price: {
      type: Number,
      default: null,
    },
  },
  computed: {
    ...mapState({
      primaryColor: state => state.primaryColor,
    }),
  },
  methods: {
    goToGoodsDetail(mid) {
      this.$emit('click', mid);
    },
  },
};
</script>

<style scoped lang="scss">
$primary-color: var(--primary-color);

.goods-item-left {
  margin: 8px 4px 8px 8px;
}
.goods-item-right {
  margin: 8px 8px 8px 4px;
}
.goods-item {
  display: flex;
  flex-direction: column;
  background-color: #fff;
  .image-wrapper {
    width: 100%;
    height: 330rpx;
    border-radius: 3px;
    overflow: hidden;
    image {
      width: 100%;
      height: 100%;
      opacity: 1;
    }
  }
  .goods-name {
    margin-left: 10px;
    font-size: 15px;
    color: #333;
    margin-top: 10px;
  }
  .goods-price-wrap {
    padding: 10px;
  }
  .goods-price-old {
    text-decoration: line-through;
    color: #999999;
  }
  .goods-price {
    margin: 5px 0 10px 10px;
    font-weight: bold;
    color: $primary-color;
    color: var(--primary-color);
    font-size: 16px;
  }
}
</style>
